import { Box, Paper, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface FeatureCardProps {
	icon: ReactNode;
	title: string;
	description: string;
}

export const FeatureCard = ({ icon, title, description }: FeatureCardProps) => {
	return (
		<Paper
			elevation={0}
			sx={{
				p: 4,
				height: "100%",
				border: "1px solid",
				borderColor: "divider",
				borderRadius: 2,
				transition: "all 0.3s ease",
				"&:hover": {
					borderColor: "primary.main",
					transform: "translateY(-4px)",
				},
			}}
		>
			<Box
				sx={{
					mb: 2,
					color: "primary.main",
					display: "flex",
					alignItems: "center",
					fontSize: "2rem",
				}}
			>
				{icon}
			</Box>
			<Typography
				variant="h6"
				sx={{
					mb: 1.5,
					fontWeight: 600,
					color: "text.primary",
				}}
			>
				{title}
			</Typography>
			<Typography
				variant="body2"
				sx={{
					color: "text.secondary",
					lineHeight: 1.7,
				}}
			>
				{description}
			</Typography>
		</Paper>
	);
};
